import { render, staticRenderFns } from "./AmountDetailPayService.vue?vue&type=template&id=c75326c0&"
import script from "./AmountDetailPayService.vue?vue&type=script&lang=ts&"
export * from "./AmountDetailPayService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports